import React, { useState, useEffect } from "react";
import Accordion from "../../hooks/Accordion";

// css
import "./offering-details.css";

const ODTable = () => {
  const [showMore, setShowMore] = useState(false);

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  const navFreqList = [
    "Monthly NAV",
    "NAV per share for each class will generally be available within 15 calendar days of quarter end and will be made available on our website and in a supplement filed with the Securities and Exchange Commission",
  ];

  const subscriptionList = [
    "Subscription agreements are submitted on an ongoing basis",
    "Purchases are effective as of the first calendar day of each month",
    "Subscription requests must be received in good order at least five business days prior to the first calendar day of the month",
  ];

  const shareRepurchaseList = [
    "Monthly repurchases will be made at the transaction price, which is generally equal to our prior month’s NAV",
    "Shares not held for at least one year will be repurchased at 95% of the transaction price",
    "Total repurchases are limited to 1.67% of the aggregate NAV per month (measured using the aggregate NAV attributable to stockholders as of the end of the immediately preceding month) and 5% of the aggregate NAV per calendar quarter (measured using the average aggregate NAV attributable to stockholders as of the end of the immediately preceding three months)",
    "Repurchase requests must be received in good order by the fifth business day prior to the last business day of the applicable month",
    "We are not obligated to repurchase any shares and may choose to repurchase only some, or even none, of the shares that have been requested to be repurchased in any particular month in our discretion",
    "The share repurchase program is subject to other limitations and our board of directors may make exceptions to, modify, suspend, or terminate the program if in our best interest and in the best interest of our stockholders",
  ];

  const liquidRepurchaseList = [
    "Monthly repurchases will be made at the transaction price, which is generally equal to our prior month's NAV",
    "Shares not held for at least one year will be repurchased at 95% of the transaction price",
    "Total repurchases are limited to approximately 1.67% of the aggregate NAV per month and 5% of the aggregate NAV per calendar quarter",
    "We may waive the Early Repurchase Deduction in the case of repurchase requests arising from the death, qualified disability or divorce of the stockholder",
  ];

  return (
    <section className="odtable-container">
      {screenSize.dynamicWidth < 900 ? (
        <div className="mb-9">
          <Accordion
            title="Offering Type"
            content="Non-traded, perpetual life real estate investment trust (REIT)"
          />
          <Accordion
            title="Targeted Assets"
            content=" Digital infrastructure assets with a focus on cell towers,
                  data centers, fiber networks, and wireless easements and lease
                  assignments"
          />
          <Accordion title="Minimum Initial Investment" content="$2,500" />
          <Accordion
            title="NAV Determination Frequency"
            content="Our NAV is determined monthly."
            sup="2"
          />
          <Accordion
            title="Anticipated Distribution Frequency"
            content="Monthly"
            sup="3"
          />
          <Accordion
            title="Investor Suitability"
            content="Investors must have either (1) a net worth of at least
                  $250,000 or (2) an annual gross income of at least $70,000 and
                  a minimum net worth of at least $70,000. Certain states have
                  additional suitability standards. See the “Suitability
                  Standards” of the prospectus for more information."
            // list={navFreqList}
            sup="3"
          />
          <Accordion
            title="Liquidity/Share Repurchase Program"
            content=""
            sup="4,5"
            list={liquidRepurchaseList}
          />
          <Accordion title="Tax Reporting" content="Form 1099-DIV" />
          {/* <Accordion title="Subscriptions" list={subscriptionList} />
          <Accordion
            title="Suitability Standards"
            content="Either (1) a net worth of at least $250,000 or (2) a gross annual income of at least $70,000 and a net worth of at least $70,000. Certain states have additional suitability standards. See the prospectus for more information"
          />
          {showMore ? (
            <div>
              <Accordion
                title="Suitability Standards"
                list={shareRepurchaseList}
              />
              <Accordion
                title="Death/Disability"
                content="We may waive the Early Repurchase Deduction in the case of repurchase requests arising from the death, qualified disability or divorce of the stockholder."
              />
              <Accordion title="Legal Council" content="Troutman Pepper" />
              <Accordion title="Auditor" content="Deloitte & Touche LLP" />
              <Accordion title="Tax Reporting" content="Form 1099-DIV" />
            </div>
          ) : null} */}
          {/* <div className="t-center show-more-wrapper">
            {showMore ? (
              <span
                className="t-center pointer"
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                Show Less -
              </span>
            ) : (
              <span
                className="t-center pointer"
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                Show More +
              </span>
            )}
          </div> */}
        </div>
      ) : (
        <div style={{ padding: "80px 80px 30px 80px" }}>
          <div className="main-margin">
            <table className="odtable-header table-shadow-main">
              <tr>
                <th className="odtable-tableheader">Terms</th>
                <th className="odtable-tableheader">Description</th>
              </tr>
              <tr>
                <td className="odheader-slim fw-6">Offering Type</td>
                <td>
                  Non-traded, perpetual life real estate investment trust (REIT)
                </td>
              </tr>
              <tr>
                <td className="fw-6">Targeted Assets</td>
                <td>
                  Digital infrastructure assets with a focus on cell towers,
                  data centers, fiber networks, and wireless easements and lease
                  assignments
                </td>
              </tr>
              <tr>
                <td className="fw-6">Minimum Initial Investment</td>
                <td>$2,500</td>
              </tr>
              <tr>
                <td className="fw-6">
                NAV Determination
                Frequency<sup>2</sup>
                </td>
                <td>Our NAV is determined monthly.</td>
              </tr>
              <tr>
                <td className="fw-6">
                  Anticipated Distribution Frequency<sup>3</sup>
                </td>
                <td>Monthly</td>
              </tr>
              <tr>
                <td className="fw-6">Investor Suitability</td>
                <td>
                  Investors must have either (1) a net worth of at least
                  $250,000 or (2) an annual gross income of at least $70,000 and
                  a minimum net worth of at least $70,000. Certain states have
                  additional suitability standards. See the “Suitability
                  Standards” of the prospectus for more information.
                </td>
              </tr>
              <tr>
                <td className="fw-6">
                  Liquidity/Share Repurchase Program<sup>4,5</sup>
                </td>
                <td>
                  <ul className="list-disc cust-ul">
                    {liquidRepurchaseList.map((li, i) => {
                      return <li key={i}>{li}</li>;
                    })}
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="fw-6">Tax Reporting</td>
                <td>Form 1099-DIV</td>
              </tr>

              {/* <tr>
                <td className="fw-6">Subscriptions</td>
                <td>
                  <ul className="cust-ul">
                    <li>
                      Subscription agreements are submitted on an ongoing basis
                    </li>
                    <li>
                      Purchases are effective as of the first calendar day of
                      each month
                    </li>
                    <li>
                      Subscription requests must be received in good order at
                      least five business days prior to the first calendar day
                      of the month
                    </li>
                  </ul>
                </td>
              </tr> */}

              {/* <tr>
                <td className="fw-6">Suitability Standards</td>
                <td>
                  Either (1) a net worth of at least $250,000 or (2) a gross
                  annual income of at least $70,000 and a net worth of at least
                  $70,000. Certain states have additional suitability standards.
                  See the prospectus for more information
                </td>
              </tr> */}

              {/* <tr className={showMore ? "table-row-show" : "table-row-hide"}>
                <td className="fw-6">Share Repurchase Program</td>
                <td>
                  <ul className="cust-ul">
                    <li>
                      Monthly repurchases will be made at the transaction price,
                      which is generally equal to our prior month’s NAV
                    </li>
                    <li>
                      Shares not held for at least one year will be repurchased
                      at 95% of the transaction price
                    </li>
                    <li>
                      Total repurchases are limited to 1.67% of the aggregate
                      NAV per month and 5% of the aggregate NAV per calendar
                      quarter (measured using the aggregate NAV attributable to
                      stockholders as of the end of the immediately preceding
                      quarter)
                    </li>
                    <li>
                      Repurchase requests must be received in good order by the
                      fifth business day prior to the last business day of the
                      applicable month
                    </li>
                    <li>
                      We are not obligated to repurchase any shares and may
                      choose to repurchase only some, or even none, of the
                      shares that have been requested to be repurchased in any
                      particular month in our discretion
                    </li>
                    <li>
                      The share repurchase program is subject to other
                      limitations and our board of directors may make exceptions
                      to, modify, suspend, or terminate the program if in our
                      best interest and in the best interest of our
                      stockholders.
                    </li>
                  </ul>
                </td>
              </tr> */}
              {/* <tr className={showMore ? "table-row-show" : "table-row-hide"}>
                <td className="fw-6">Death/Disability</td>
                <td>
                  We may waive the Early Repurchase Deduction in the case of
                  repurchase requests arising from the death, qualified
                  disability or divorce of the stockholder.
                </td>
              </tr>
              <tr className={showMore ? "table-row-show" : "table-row-hide"}>
                <td className="fw-6">Legal Council</td>
                <td>Troutman Pepper</td>
              </tr>
              <tr className={showMore ? "table-row-show" : "table-row-hide"}>
                <td className="fw-6">Auditor</td>
                <td>Deloitte & Touche LLP</td>
              </tr>
              <tr className={showMore ? "table-row-show" : "table-row-hide"}>
                <td className="fw-6">Tax Reporting</td>
                <td>Form 1099-DIV</td>
              </tr> */}
            </table>
            {/* <div className="t-center show-more-wrapper">
              {showMore ? (
                <span
                  className="t-center pointer"
                  onClick={() => {
                    setShowMore(!showMore);
                  }}
                >
                  Show Less -
                </span>
              ) : (
                <span
                  className="t-center pointer"
                  onClick={() => {
                    setShowMore(!showMore);
                  }}
                >
                  Show More +
                </span>
              )}
            </div> */}
          </div>
        </div>
      )}
    </section>
  );
};

export default ODTable;
